import { AnchorElementsSource } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { GetSharingInfoResponseBase } from 'owa-fileprovider-link-services';
import { action } from 'satcheljs';

export const onSharingLinkDetected = action(
    'ON_SHARING_LINK_DETECTED',
    (
        linkId: string,
        linkUrl: string,
        sharingLinkIds: string[],
        response: GetSharingInfoResponseBase,
        shouldAddComposeLinkViewState: boolean,
        isPreviouslyBeautified: boolean,
        source: AnchorElementsSource,
        providerType: AttachmentDataProviderType
    ) => ({
        linkId: linkId,
        linkUrl: linkUrl,
        sharingLinkIds: sharingLinkIds,
        response: response,
        shouldAddComposeLinkViewState: shouldAddComposeLinkViewState,
        isPreviouslyBeautified: isPreviouslyBeautified,
        source: source,
        providerType: providerType,
    })
);
